export default async (url, options) => {
  const res = await fetch(url, {
    ...options,
    mode: 'same-origin',
    cache: 'no-cache',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
    },
  });
  const resJSON = await res.json();
  if (!res.ok) {
    throw new Error(resJSON.error || 'RefreshError');
  }
  return resJSON;
};
